import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService, Gametype } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class GametypeService {
  constructor(private dataService: DataService) {}

  getGametypes(): Observable<Gametype[]> {
    return this.dataService.getData().pipe(
      map(data => (data.gametypes || []).sort((a, b) => a.order - b.order))
    );
  }

  getTopGametype(): Observable<Gametype | null> {
    return this.getGametypes().pipe(
      map(gametypes => gametypes.find(gt => gt.order === 1) || null)
    );
  }
}

